import { TFunction } from "i18next";
import DefaultIzProvider from "./DefaultIzProvider";

export class NorthDakota extends DefaultIzProvider {
  constructor(izDestinationId: string, t: TFunction) {
    super(izDestinationId, t);
    this.scenarioBImagePath = "/assets/images/large/Docket_NorthDakota_scb_f.png";
    this.reportTitles = [t("immunizations.records_history_report_nd")];
  }

  fillOutI18nDefinitions(): never {
    throw new Error("Method not implemented.");
  }
}
